define('modules/common/controller/ModalPrivacy',[], function() {
    var Controller = function(
        $scope,
        $modalInstance) {

        $scope.closeModal = function() {
            $modalInstance.close();
        };

    };

    return [
        "$scope",
        "$modalInstance",
        Controller
    ];
});
